import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableLossPrevention = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableLossPrevention);
};
